import script from "./QuestionsAndAnswers.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionsAndAnswers.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionsAndAnswers.vue?vue&type=style&index=0&id=a983a0d0&lang=scss"

const __exports__ = script;

export default __exports__